import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useCallback } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { useFocusMode } from "../../focusMode";
import { BannerLinkOverflow } from "../styled/BannerLinkOverflow";
import { BannerLinkStyled } from "../styled/BannerLinkStyled";
export const BannerLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    clientId,
    isDisabled,
    onClick: providedOnClick,
    onDoubleClick: providedOnDoubleClick,
    onKeyPress: providedOnKeyPress,
    ...rest
  } = _ref;
  const onClick = useCallback(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  const onDoubleClick = useCallback(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  const onKeyPress = useCallback(e => {
    if (e.key === "Enter" || e.key === " ") {
      onClick(e);
    }
    if (providedOnKeyPress) {
      providedOnKeyPress(e);
    }
  }, [onClick, providedOnKeyPress]);
  const {
    focusMode
  } = useFocusMode();
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(BannerLinkStyled, _extends({
    focusMode: focusMode,
    tabIndex: 0,
    "aria-disabled": isDisabled,
    themeMode: themeMode,
    onClick: onClick,
    onKeyPress: onKeyPress,
    onDoubleClick: onDoubleClick,
    "data-client-id": clientId
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(BannerLinkOverflow, null, children));
});
BannerLink.displayName = "BannerLink";
//# sourceMappingURL=BannerLink.js.map